import { Button, MenuItem, Popover, Tooltip, Typography } from "@material-ui/core";
import { PlayArrow } from "@material-ui/icons";
import React from "react";
import ReadleeAudioPlayer from "./ReadleeAudioPlayer";
import "./OverflowButtons.css";

interface ScreenProps {
  isCompleted: boolean;
  audioUrls: string[];
  audioDurations: number[];
  onStartRecording: () => void;
  onDeleteRecording: () => void;
}

const OverflowButtons = (props: ScreenProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | HTMLInputElement | undefined>(undefined);
  const [audioAnchorEl, setAudioAnchorEl] = React.useState<Element | undefined>(undefined);

  function handleClose() {
    setAnchorEl(undefined);
  }

  return (
    <div className="buttonContainer">
      <Button className="overflowButton" onClick={event => setAnchorEl(event.currentTarget)}>
        <Tooltip title="More actions">
          <div>...</div>
        </Tooltip>
      </Button>
      {props.isCompleted ? (
        <Tooltip title="Listen to your reading">
          <Button className="overflowButton">
            <PlayArrow
              className="rightActionIcon"
              onClick={event => {
                setAudioAnchorEl(event.currentTarget);
              }}
            />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title="Continue recording your reading">
          <Button
            className="button"
            onClick={() => {
              props.onStartRecording();
            }}
          >
            <Typography className="buttonText">Resume</Typography>
          </Button>
        </Tooltip>
      )}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {props.isCompleted ? (
          <div className="overflowMenu popoverAlignment">
            <Tooltip title="Continue recording your reading">
              <MenuItem
                className="overFlowMenuText"
                onClick={() => {
                  props.onStartRecording();
                  handleClose();
                }}
              >
                Continue Recording
              </MenuItem>
            </Tooltip>
            <Tooltip title="Delete your recording">
              <MenuItem
                className="overFlowMenuText"
                onClick={() => {
                  props.onDeleteRecording();
                  handleClose();
                }}
              >
                Delete Recording
              </MenuItem>
            </Tooltip>
          </div>
        ) : (
          <div className="overflowMenu popoverAlignment">
            <Tooltip title="Listen to your reading">
              <MenuItem
                className="overFlowMenuText"
                onClick={() => {
                  // Needs to be the anchorEl because the menu is gone on the next render
                  setAudioAnchorEl(anchorEl);
                  handleClose();
                }}
              >
                Play Recording
              </MenuItem>
            </Tooltip>
            <Tooltip title="Delete your recording">
              <MenuItem
                className="overFlowMenuText"
                onClick={() => {
                  props.onDeleteRecording();
                }}
              >
                Delete Recording
              </MenuItem>
            </Tooltip>
          </div>
        )}
      </Popover>
      <Popover
        open={Boolean(audioAnchorEl)}
        anchorEl={audioAnchorEl}
        onClose={() => {
          setAudioAnchorEl(undefined);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div className="audioPlayerPopover">
          <ReadleeAudioPlayer audioUrls={props.audioUrls} audioDurations={props.audioDurations} />
        </div>
      </Popover>
    </div>
  );
};

export default OverflowButtons;
